/**
 * Alignment status for factor breakdown
 */
export enum AlignmentStatus {
  ALIGNED = 'aligned',
  FRAGMENTED = 'fragmented',
  MIXED = 'mixed',
}

/**
 * Breakdown of alignment status for each factor
 */
export interface AlignmentBreakdown {
  positions: AlignmentStatus;
  volume: AlignmentStatus;
  recentFlow: AlignmentStatus;
}

/**
 * Data structure for directional agreement statistics
 */
export interface DirectionalAgreementData {
  agreementScore: number; // 0-100
  scoreDescription: string;
  alignmentLabel: string;
  sampleCount: number;
  breakdown: AlignmentBreakdown;
  inactiveDays?: { current: number; total: number };
}

/**
 * Main component props for DirectionalAgreement
 */
export interface DirectionalAgreementProps {
  symbol: string;
  data?: DirectionalAgreementData;
  isLoading?: boolean;
  isExpanded?: boolean;
  onToggleExpand?: () => void;
  onInfoClick?: () => void;
}

/**
 * Props for the Card Header component
 */
export interface CardHeaderProps {
  title: string;
  sampleCount: number;
  inactiveDays?: { current: number; total: number };
  onInfoClick?: () => void;
}

/**
 * Props for the Agreement Gauge component
 */
export interface AgreementGaugeProps {
  score: number;
  scoreDescription: string;
  alignmentLabel: string;
}

/**
 * Props for the Factor Card component
 */
export interface FactorCardProps {
  icon: 'positions' | 'volume' | 'recentFlow';
  label: string;
  status: AlignmentStatus;
}

/**
 * Props for the Factor Cards container component
 */
export interface FactorCardsProps {
  breakdown: AlignmentBreakdown;
}

/**
 * Props for the Educational Section component
 */
export interface EducationalSectionProps {
  isExpanded: boolean;
  onToggle: () => void;
}
